// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import MediaPlayer from 'components/MediaPlayer/MediaPlayer'

// Redux:
import { getVideosData } from 'actions/site'

class Videos extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		dispatch( getVideosData() )
	}

	render() {
		const { match, videos } = this.props
		const currentSlug = match.params.video
		let videosMarkup,
			selectedVideo

		if ( videos[ `id_${currentSlug}` ] ) {
			selectedVideo = videos[ `id_${currentSlug}` ]
		}

		if ( Object.keys( videos ).length ) {
			videosMarkup =  Object.keys( videos ).map( ( key ) => {
				let item = videos[ key ]

				if ( item.slug == currentSlug ) {
					return
				}

				return (
					<div className="-video-wrap" key={ key }>
						<Link to={ `/video/${item.slug}` } className="-video">
							<div className="-image">
								<img
									src={ item.image.url }
									srcSet={ item.image.srcset }
									sizes={ `(max-width: ${siteData.mobile_max_width}) 50vw, 400px` }
									alt={ item.image.alt }
								/>
							</div>

							<div className="-text">
								<h3 className="-title">{ item.title }</h3>
							</div>
						</Link>
					</div>
				)
			})
		}

		return (
			<div className="videos-wrap">
				<div className="-selected">
					{ selectedVideo &&
						<div className="-selected-video">
							<MediaPlayer url={ selectedVideo.video_url } />
						</div>
					}
				</div>

				<div className="-past-videos">
					{ videosMarkup }
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		videos: state.site.videos
	}
}

export default connect( mapStateToProps )( Videos )



// WEBPACK FOOTER //
// ./views/page/Videos.jsx